<template>
  <div class="modal fade" style="background-color: rgba(7,7,7,0.36);" id="trail-import-dialog" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body p-5">
          <div class="row">
            <div class="col-8">
              <p class="display-5"><strong>Import Hikes</strong></p>
              <p><small>Start your plan with a HiiKER hike or from your own custom hikes</small></p>
            </div>
            <div class="col-4">
              <button class="btn btn-block btn-primary d-flex align-items-center justify-content-center" @click="importGPXClicked">
                Upload file
              </button>
            </div>
          </div>

          <div class="input-group hero-search mt-2 py-2">
            <input
              autocomplete="off"
              class="form-control search-bar__input pl-3"
              id="trail-input"
              type="text"
              v-model="searchString"
              :placeholder="placeholder"
            />
            <span class="input-group-append d-flex align-items-center">
              <span class="input-group-text">
                <span class="material-icons">search</span>
              </span>
            </span>
          </div>

          <div v-if="hasSearchTerm" class="mt-3">
            <ul class="nav nav-tabs mb-4" role="tablist">
              <li class="nav-item m-0" role="presentation">
                <button
                  class="nav-link"
                  :class="{ active: activeTab === 'curated' }"
                  id="trail-import-tab-curated"
                  data-bs-toggle="tab"
                  data-bs-target="#trail-import-pane-curated"
                  type="button"
                  role="tab"
                  @click="setActiveTab('curated')"
                >
                  Popular ({{ curatedTrailResults.length }})
                </button>
              </li>
              <li class="nav-item m-0" role="presentation">
                <button
                  class="nav-link"
                  :class="{ active: activeTab === 'planned' }"
                  id="trail-import-tab-planned"
                  data-bs-toggle="tab"
                  data-bs-target="#trail-import-pane-planned"
                  type="button"
                  role="tab"
                  @click="setActiveTab('planned')"
                >
                  My Hikes ({{ plannedTrailResults.length }})
                </button>
              </li>
              <li class="nav-item m-0" role="presentation">
                <button
                  class="nav-link"
                  :class="{ active: activeTab === 'recorded' }"
                  id="trail-import-tab-recorded"
                  data-bs-toggle="tab"
                  data-bs-target="#trail-import-pane-recorded"
                  type="button"
                  role="tab"
                  @click="setActiveTab('recorded')"
                >
                  Recordings ({{ recordedTrailResults.length }})
                </button>
              </li>
            </ul>

            <div class="tab-content mt-3 big-list">
              <div
                class="tab-pane fade"
                :class="{ 'show active': activeTab === 'curated' }"
                id="trail-import-pane-curated"
                role="tabpanel"
                aria-labelledby="trail-import-tab-curated"
              >
                <div v-if="curatedTrailResults.length === 0" class="text-center text-muted py-4">
                  No HiiKER hikes found
                </div>
                <template v-else>
                  <TrailImportDialogSearchResultsListItem
                    v-for="result in curatedTrailResults.slice(0, curatedTrailShowMore ? 1000 : 5)"
                    :key="result.document.id"
                    :name="result.document.name"
                    :distance-meters="result.document.distance_meters"
                    :elevation-gain-meters="result.document.elevation_gain_meters"
                    :difficulty="result.document.difficulty"
                    :thumbnail-url="result.document.square_static_map_image_url || result.document.static_map_url"
                    :obj="result"
                    :click="curatedTrailClicked"
                  />
                  <div v-if="!curatedTrailShowMore && curatedTrailResults.length > 5" class="d-flex justify-content-center align-items-center">
                    <button class="btn btn-link" @click="curatedTrailShowMore = true">Show More</button>
                  </div>
                </template>
              </div>

              <div
                class="tab-pane fade"
                :class="{ 'show active': activeTab === 'planned' }"
                id="trail-import-pane-planned"
                role="tabpanel"
                aria-labelledby="trail-import-tab-planned"
              >
                <div v-if="plannedTrailResults.length === 0" class="text-center text-muted py-4">
                  No hikes found
                </div>
                <template v-else>
                  <TrailImportDialogSearchResultsListItem
                    v-for="hike in plannedTrailResults.slice(0, plannedTrailShowMore ? 1000 : 5)"
                    :key="hike.id"
                    :name="hike.name"
                    :distance-meters="hike.distanceMeters"
                    :elevation-gain-meters="hike.elevationGainMeters"
                    :difficulty="hike.difficulty"
                    :thumbnail-url="hike.staticMapImageUrl"
                    :obj="hike"
                    :click="planedTrailClicked"
                  />
                  <div v-if="!plannedTrailShowMore && plannedTrailResults.length > 5" class="d-flex justify-content-center align-items-center">
                    <button class="btn btn-link" @click="plannedTrailShowMore = true">Show More</button>
                  </div>
                </template>
              </div>

              <div
                class="tab-pane fade"
                :class="{ 'show active': activeTab === 'recorded' }"
                id="trail-import-pane-recorded"
                role="tabpanel"
                aria-labelledby="trail-import-tab-recorded"
              >
                <div v-if="recordedTrailResults.length === 0" class="text-center text-muted py-4">
                  No recordings found
                </div>
                <template v-else>
                  <TrailImportDialogSearchResultsListItem
                    v-for="recordedTrail in recordedTrailResults.slice(0, recordedTrailShowMore ? 1000 : 5)"
                    :key="recordedTrail.id"
                    :name="recordedTrail.title"
                    :distance-meters="recordedTrail.distanceMeters"
                    :thumbnail-url="recordedTrail.thumbnailUrl"
                    :obj="recordedTrail"
                    :click="recordedTrailClicked"
                  />
                  <div v-if="!recordedTrailShowMore && recordedTrailResults.length > 5" class="d-flex justify-content-center align-items-center">
                    <button class="btn btn-link" @click="recordedTrailShowMore = true">Show More</button>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div v-else class="text-center text-muted py-4">
            <p>Start typing to search for hikes</p>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary mr-2" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
    <LoadingDialog :show-loading-dialog="loading"/>
    <ImportChoiceDialog ref="importChoiceDialog" />
    <RouteSelector ref="routeSelector" />
  </div>
</template>

<script>

import { defineComponent } from 'vue';
// eslint-disable-next-line import/extensions,import/no-unresolved,camelcase
import graph_client from '../../utils/graphql/graph_client';
import { GetPtv2PlannedTrail, SearchUsersPlannedTrails } from '../../utils/graphql/planned-trail-graph.ts';
import { GetRecordedTrailById, SearchUsersRecordedTrails } from '../../utils/graphql/recorded-trail-graph.ts';
import { GetTrail } from '../../utils/graphql/trail-graph.ts';
import { SearchUserHikesSimple, GetHike } from '../../utils/graphql/hikes-graph.ts';
import { MeasurementPrefUtility } from '../../utils/helpers/MeasurementPref.ts';
import { search } from '../../utils/helpers/TypsenseClientHelper.ts';
import LoadingDialog from '../../utils/shared_components/LoadingDialog.vue';
import TrailImportDialogSearchResultsListItem from './TrailImportDialogSearchResultsListItem.vue';
import ImportChoiceDialog from './ImportChoiceDialog.vue';
import RouteSelector from './RouteSelector.vue';
import { appCheck } from "../../utils/firebase/appCheck"
import { getToken } from "firebase/app-check";
import emitter from "../../utils/bus";
import { Modal } from 'bootstrap';

export default defineComponent({
  components: {
    LoadingDialog,
    TrailImportDialogSearchResultsListItem,
    ImportChoiceDialog,
    RouteSelector,
  },
  data() {
    return {
      loading: false,
      searchString: '',
      placeholder: 'Search for a location (London) or Enter GPS coordinates',
      curatedTrailResults: [],
      curatedTrailShowMore: false,
      plannedTrailResults: [],
      plannedTrailShowMore: false,
      recordedTrailResults: [],
      recordedTrailShowMore: false,
      measurementPreference: null,
      activeTab: 'curated',
    };
  },
  computed: {
    hasSearchTerm() {
      return this.searchString.trim().length >= 2;
    },
  },
  watch: {
    searchString() {
      const value = this.searchString.trim();
      if (value.length < 2) {
        this.curatedTrailResults = [];
        this.plannedTrailResults = [];
        this.recordedTrailResults = [];
        this.curatedTrailShowMore = false;
        this.plannedTrailShowMore = false;
        this.recordedTrailShowMore = false;
        this.activeTab = 'curated';
        return;
      }
      search(value).then((response) => {
        this.curatedTrailResults = response.hits;
        console.log(`${response.hits.length} curated results found`);
        this.ensureActiveTab();
      });
      graph_client.request(SearchUserHikesSimple, { query: value }).then((response) => {
        this.plannedTrailResults = response.searchUserHikes;
        console.log(`${this.plannedTrailResults.length} hike results found`);
        this.ensureActiveTab();
      }).catch((error) => {
        console.log(error);
      });
      graph_client.request(SearchUsersRecordedTrails, { string: value }).then((response) => {
        this.recordedTrailResults = response.recordingsTextSearch;
        console.log(`${this.recordedTrailResults.length} recorded results found`);
        this.ensureActiveTab();
      }).catch((error) => {
        console.log(error);
      });
    },
  },
  async mounted() {
    this.placeholder = 'Search or a hike...';
    this.measurementPreference = MeasurementPrefUtility.preference();
  },
  methods: {
    search() {
      console.log('search');
    },
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    ensureActiveTab() {
      if (this.activeTab !== 'curated') {
        return;
      }

      if (this.curatedTrailResults.length === 0) {
        if (this.plannedTrailResults.length > 0) {
          this.activeTab = 'planned';
          return;
        }

        if (this.recordedTrailResults.length > 0) {
          this.activeTab = 'recorded';
          return;
        }
      }
    },
    importGPXClicked() {
      const input = document.getElementById('file-selector');
      if (!input) {
        return;
      }

      input.type = 'file';
      input.accept = '.gpx,.kml,.kmz,.tcx,.geojson,application/gpx+xml,application/vnd.google-earth.kml+xml,application/vnd.google-earth.kmz,application/json';
      input.value = '';

      const self = this;
      input.onchange = async (e) => {
        const target = e.target;
        if (!(target instanceof HTMLInputElement) || !target.files || target.files.length === 0) {
          return;
        }

        const file = target.files[0];

        try {
          await self.$store.dispatch('planTrail/importFile', file);
        } finally {
          target.value = '';
        }
      };

      input.click();
    },
    async curatedTrailClicked(hike) {
      this.loading = true;
      // Fetch full hike data to check if it has multiple routes
      graph_client.request(GetHike, { id: hike.document.id }).then((response) => {
        this.loading = false;
        const fullHike = response.hike;
        const routes = fullHike.hikesPlannedTrails || [];

        // If hike has more than 1 route, show route selector
        if (routes.length > 1) {
          const routeSelector = this.$refs.routeSelector;
          const selectorElement = document.getElementById('route-selector-dialog');
          const selectorModal = new Modal(selectorElement);

          routeSelector.show(fullHike, (selectedTrails) => {
            selectorModal.hide();
            // Official HiiKER hikes should always be copied, never referenced
            this.importSelectedRoutes(selectedTrails, 'copy', fullHike.hikeDays || []);
          });

          selectorModal.show();
        } else {
          // Single route or no routes - import the whole hike
          // eslint-disable-next-line no-restricted-globals
          const confirmed = confirm('Do you want to import this hike as a new route?');
          if (confirmed) {
            this.importWholeHike(fullHike);
          }
        }
      }).catch((error) => {
        console.log(error);
        this.loading = false;
      });
    },
    planedTrailClicked(hike) {
      this.loading = true;
      // Fetch full hike data to check if it has multiple routes
      graph_client.request(GetHike, { id: hike.id }).then((response) => {
        this.loading = false;
        const fullHike = response.hike;
        const routes = fullHike.hikesPlannedTrails || [];

        // If hike has more than 1 route, show route selector
        if (routes.length > 1) {
          const routeSelector = this.$refs.routeSelector;
          const selectorElement = document.getElementById('route-selector-dialog');
          const selectorModal = new Modal(selectorElement);

          routeSelector.show(fullHike, (selectedTrails) => {
            selectorModal.hide();

            // Show import choice dialog (reference vs copy)
            const choiceDialog = this.$refs.importChoiceDialog;
            const choiceElement = document.getElementById('import-choice-dialog');
            const choiceModal = new Modal(choiceElement);

            choiceDialog.show(null, (choice) => {
              choiceModal.hide();
              this.importSelectedRoutes(selectedTrails, choice, fullHike.hikeDays || []);
            });

            choiceModal.show();
          });

          selectorModal.show();
        } else {
          // Single route or no routes - import the whole hike
          // eslint-disable-next-line no-restricted-globals
          const confirmed = confirm('Do you want to import this hike as a new route?');
          if (confirmed) {
            this.importWholeHike(fullHike);
          }
        }
      }).catch((error) => {
        console.log(error);
        this.loading = false;
      });
    },
    recordedTrailClicked(trail) {
      this.loading = true;
      graph_client.request(GetRecordedTrailById, { slug: trail.id }).then((response) => {
        // eslint-disable-next-line no-restricted-globals
        const confirmed = confirm('Do you want to import this trail as a new route?');
        this.loading = false;
        if (confirmed) {
          let geojson = JSON.parse(response.recordingBySlug.lineString)
          geojson.features[0].properties.name = trail.title;
          emitter.emit('update-geojson', { geoJson: geojson, trailName: trail.title });
          const element = document.getElementById('trail-import-dialog');
          const modal = Modal.getInstance(element);
          modal.hide();
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    myRouteClicked(route) {
      // Show the import choice dialog
      const choiceDialog = this.$refs.importChoiceDialog;
      const choiceElement = document.getElementById('import-choice-dialog');
      const choiceModal = new Modal(choiceElement);

      choiceDialog.show(route, (choice, selectedRoute) => {
        choiceModal.hide();

        // Fetch the geojson for the route
        this.loading = true;
        graph_client.request(GetPtv2PlannedTrail, { id: selectedRoute.id }).then((response) => {
          this.loading = false;
          let geojson = response.ptv2PlannedTrailById.geojsonFeatureCollection;
          geojson.features[0].properties.name = selectedRoute.title;

          if (choice === 'reference') {
            // Import as reference - pass all data as single object
            const importData = {
              geoJson: geojson,
              trailName: selectedRoute.title,
              plannedTrailId: selectedRoute.id,
              referencedHikes: selectedRoute.hikes || []
            };
            emitter.emit('update-geojson', importData);
          } else {
            // Import as copy - no reference data
            const importData = {
              geoJson: geojson,
              trailName: selectedRoute.title
            };
            emitter.emit('update-geojson', importData);
          }

          // Close the main import dialog
          const element = document.getElementById('trail-import-dialog');
          const modal = Modal.getInstance(element);
          modal.hide();
        }).catch((error) => {
          console.log(error);
          this.loading = false;
        });
      });

      choiceModal.show();
    },
    importWholeHike(hike) {
      // Import the entire hike as one route
      const routes = hike.hikesPlannedTrails || [];
      if (routes.length === 0) {
        alert('This hike has no routes to import.');
        return;
      }

      // For a single route hike, just import that route
      if (routes.length === 1) {
        const route = routes[0];
        this.loading = true;
        graph_client.request(GetPtv2PlannedTrail, { id: route.ptv2PlannedTrail.id }).then((response) => {
          this.loading = false;
          let geojson = response.ptv2PlannedTrailById.geojsonFeatureCollection;

          // Calculate the next available day
          const routesObj = this.$store.state.planTrail?.routes || {};
          const allExistingRoutes = Object.values(routesObj);
          const existingRoutes = allExistingRoutes.filter(r => {
            return (r.lineStrings && r.lineStrings.length > 0) ||
                   (r.markers && r.markers.length > 0);
          });

          // If there are no non-empty routes, remove all empty routes
          if (existingRoutes.length === 0 && allExistingRoutes.length > 0) {
            allExistingRoutes.forEach(emptyRoute => {
              this.$store.commit('planTrail/removeRoute', emptyRoute.id);
            });
          }

          const maxExistingDay = existingRoutes.reduce((max, r) => {
            return Math.max(max, r.day || 1);
          }, 0);

          const newDay = maxExistingDay + 1;
          const routeStyle = route.ptv2PlannedTrail.routeStyle || 'route';

          geojson.features[0].properties.name = route.ptv2PlannedTrail.title || hike.name;
          emitter.emit('update-geojson', {
            geoJson: geojson,
            trailName: route.ptv2PlannedTrail.title || hike.name,
            day: newDay,
            route_style: routeStyle
          });

          const element = document.getElementById('trail-import-dialog');
          const modal = Modal.getInstance(element);
          modal.hide();
        }).catch((error) => {
          console.log(error);
          this.loading = false;
        });
      }
    },
    importSelectedRoutes(selectedTrails, choice = 'copy', hikeDays = []) {
      if (selectedTrails.length === 0) {
        return;
      }

      // Import each route individually
      this.loading = true;
      const promises = selectedTrails.map((trail) => {
        const routeId = trail.ptv2PlannedTrail?.id || trail.id;
        return graph_client.request(GetPtv2PlannedTrail, { id: routeId });
      });

      Promise.all(promises).then((responses) => {
        this.loading = false;

        // Filter out empty responses (routes with no geojson data)
        const validTrailsAndResponses = [];
        selectedTrails.forEach((trail, index) => {
          const response = responses[index];
          const geojson = response.ptv2PlannedTrailById?.geojsonFeatureCollection;

          // Check if geojson exists and has features with coordinates
          if (geojson && geojson.features && geojson.features.length > 0) {
            const hasValidGeometry = geojson.features.some(feature => {
              return feature.geometry &&
                     feature.geometry.coordinates &&
                     feature.geometry.coordinates.length > 0;
            });

            if (hasValidGeometry) {
              validTrailsAndResponses.push({ trail, response, index });
            }
          }
        });

        // If no valid routes, show message and exit
        if (validTrailsAndResponses.length === 0) {
          alert('No valid routes to import. All selected routes appear to be empty.');
          return;
        }

        // Group routes by day for proper import
        const routesByDay = new Map();
        validTrailsAndResponses.forEach(({ trail }) => {
          const day = trail.day;
          if (!routesByDay.has(day)) {
            routesByDay.set(day, []);
          }
          routesByDay.get(day).push(trail);
        });

        // Get the unique days sorted
        const days = Array.from(routesByDay.keys()).sort((a, b) => (a || 0) - (b || 0));

        // Calculate the next available day in the planner
        // Filter out empty routes (routes without lineStrings or markers)
        const routesObj = this.$store.state.planTrail?.routes || {};
        const allExistingRoutes = Object.values(routesObj);
        const existingRoutes = allExistingRoutes.filter(route => {
          return (route.lineStrings && route.lineStrings.length > 0) ||
                 (route.markers && route.markers.length > 0);
        });

        // If there are no non-empty routes, this is likely a fresh planner session
        // Remove all empty routes before importing
        if (existingRoutes.length === 0 && allExistingRoutes.length > 0) {
          allExistingRoutes.forEach(emptyRoute => {
            this.$store.commit('planTrail/removeRoute', emptyRoute.id);
          });
        }

        const maxExistingDay = existingRoutes.reduce((max, route) => {
          return Math.max(max, route.day || 1);
        }, 0);

        // Map original days to new days in the planner
        const dayMapping = new Map();
        days.forEach((originalDay, index) => {
          dayMapping.set(originalDay, maxExistingDay + index + 1);
        });

        // Build day name map using the original→new day mapping
        const dayNamesMap = {};
        if (hikeDays.length > 0) {
          days.forEach((originalDay) => {
            const newDay = dayMapping.get(originalDay);
            const dayInfo = hikeDays.find(d => d.dayNumber === originalDay);
            if (newDay && dayInfo && (dayInfo.name || dayInfo.description)) {
              dayNamesMap[newDay] = {
                name: dayInfo.name || '',
                description: dayInfo.description || ''
              };
            }
          });
        }

        // Emit each valid route with the correct day
        validTrailsAndResponses.forEach(({ trail, response, index }) => {
          const geojson = response.ptv2PlannedTrailById.geojsonFeatureCollection;
          const name = trail.ptv2PlannedTrail?.title || `Route ${index + 1}`;
          const originalDay = trail.day;
          const newDay = dayMapping.get(originalDay) || (maxExistingDay + 1);
          const routeStyle = trail.ptv2PlannedTrail?.routeStyle || 'route';

          geojson.features[0].properties.name = name;

          const importData = {
            geoJson: geojson,
            trailName: name,
            day: newDay,
            route_style: routeStyle
          };

          // If reference, add reference data
          if (choice === 'reference') {
            importData.plannedTrailId = trail.ptv2PlannedTrail?.id || trail.id;
            importData.referencedHikes = trail.ptv2PlannedTrail?.hikes || [];
          }

          emitter.emit('update-geojson', importData);
        });

        // After all routes are emitted, merge in day names if any
        if (Object.keys(dayNamesMap).length > 0) {
          emitter.emit('merge-day-names', dayNamesMap);
        }

        const element = document.getElementById('trail-import-dialog');
        const modal = Modal.getInstance(element);
        modal.hide();
      }).catch((error) => {
        console.log(error);
        this.loading = false;
      });
    },
  },
});
</script>

<style lang="scss" scoped>

.nav-tabs {
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;

  .nav-item {
    flex-shrink: 0;
  }

  .nav-link {
    font-size: 0.85rem;
    padding: 0.75rem 1rem;
    white-space: nowrap;
  }
}

@media (max-width: 768px) {
  .nav-tabs .nav-link {
    text-align: center;
    font-size: 0.75rem;
    padding: 0.75rem 0.5rem;
  }
}

.dark-popup .mapboxgl-popup-content {
  background-color: #17181d;
  color: white;
  font-size: 13px;
  padding: 1em;
  border-radius: 8px;
  max-height: 350px; /* Set a maximum height */
  overflow-y: auto; /* Enable vertical scrolling */
}

.dark-popup .mapboxgl-popup-tip {
  border-top-color: #17181d;
}

.mapboxgl-popup-anchor-top .mapboxgl-popup-tip{
  border-bottom-color: #17181d !important;
}

.dark-popup .popup-content {
  max-width: 300px;
}

.modal-md{
  max-width: 840px !important;
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}

</style>
